export const bankNames = {
  alianza: "Alianza Fiduciaria",
  santander: "Banco Santander Colombia",
  coofinep: "COOFINEP",
  avvillas: "Banco AV Villas",
  cotrafa: "Cotrafa",
  movii: "MOVii",
  dale: "Dale!",
  confiar: "Confiar",
  union: "Banco Union (antes Giros)",
  rappipay: "RappiPay",
  nequi: "Nequi",
  bancoagrario: "Banco Agrario",
  bancoomeva: "Bancoomeva",
  bancamia: "Bancamía",
  coopcentral: "Banco Cooperativo Coopcentral",
  citibank: "Citibank",
  lulo: "Lulo Bank",
  bancodeoccidente: "Banco de Occidente",
  falabella: "Banco Falabella",
  bancodebogota: "Banco de Bogotá",
  bancocajasocial: "Banco Caja Social",
  serfinanza: "Banco Serfinanza",
  cfa: "Cooperativa Financiera de Antioquia",
  coltefinanciera: "Coltefinanciera",
  pichincha: "Banco Pichincha",
  iris: "IRIS",
  ban100: "Ban100 (antes Credifinanciera)",
  bancopopular: "Banco Popular",
  daviplata: "DaviPlata",
  bancolombia: "Bancolombia",
  finandina: "Banco Finandina",
  scotiabankcolpatria: "DAVIbank",
  gnbsudameris: "GNB Sudameris",
  itau: "Banco Itaú",
  bbva: "BBVA Colombia",
  davivienda: "Davivienda",
  mibanco: "Mibanco",
  multibank: "Multibank",
  mundomujer: "Mundo Mujer",
  procreditcolombia: "Procredit Colombia",
  bancow: "Banco W",
  bancoldex: "Bancóldex",
  juriscoop: "Financiera Juriscoop",
  itauhelm: "Itaú (Helm Bank)",
  jpmorgancolombia: "JP Morgan Colombia",
  asopagos: "Asopagos",
  pibank: "Pibank",
  jfk: "JFK Cooperativa Financiera",
  ding: "DING",
  uala: "Ualá",
  btgpactual: "BTG Pactual",
  powwi: "Powwi",
  bold: "Bold",
  coink: "Coink",
  santanderconsumer: "Santander Consumer",
  global66: "Global66",
  crezcamos: "Crezcamos",
  nu: "Nu",
  accion: "Accion Fiduciaria",
  paycash: "PayCash",
} as const;

export type BankCode = keyof typeof bankNames;

export const getBankName = (code: string): string => {
  return bankNames[code as BankCode] ?? code;
};

const manualPaymentMethodNames: Record<string, string> = {
  avalPay: "Aval Pay",
  jelpit: "Jelpit",
  wompi: "Wompi",
};

export const getPayoutChannelName = (payout: {
  bank?: string;
  manualPaymentMethod?: string;
}): string =>
  payout.bank
    ? getBankName(payout.bank)
    : manualPaymentMethodNames[payout.manualPaymentMethod ?? ""] ?? "Manual";
